"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShroudOfImmortalityAbilityHandler = exports.ShroudOfImmortalityActorAbilityFactory = exports.ShroudOfImmortalityAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const CRAZY_HIGH = 1000000;
class ShroudOfImmortalityAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ShroudOfImmortality;
        this.__typeName = "ShroudOfImmortality";
    }
}
exports.ShroudOfImmortalityAbilityArgs = ShroudOfImmortalityAbilityArgs;
let ShroudOfImmortalityActorAbilityFactory = class ShroudOfImmortalityActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ShroudOfImmortality", "Self", 8);
    }
};
ShroudOfImmortalityActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ShroudOfImmortality")
], ShroudOfImmortalityActorAbilityFactory);
exports.ShroudOfImmortalityActorAbilityFactory = ShroudOfImmortalityActorAbilityFactory;
let ShroudOfImmortalityAbilityHandler = class ShroudOfImmortalityAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.addCompanion(sequence, ability.invokerId, new ActorArgs_1.NpcActorArgs(container.getFaction(ability.invokerId), ActorType_1.ActorType.ShroudOfImmortality, container.getLevel(ability.invokerId), {
            [__1.AttributeType.Health]: 20000
        }, {})
            .withAi("NoOp", {}));
        const resistanceEffectIds = [
            container.applyBuff({
                sequence,
                creatorId: ability.invokerId,
                targetId: ability.invokerId,
                effect: new __1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.AllDamageResistance, CRAZY_HIGH),
                duration: Duration_1.Duration.Permanent,
                supernatural: true,
            })
        ];
        const shroudId = container.getActor(ability.invokerId).companionIds[0];
        container.registerEventHandler(shroudId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CancelEffectsEventHandlerArgs(resistanceEffectIds));
    }
};
ShroudOfImmortalityAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ShroudOfImmortality)
], ShroudOfImmortalityAbilityHandler);
exports.ShroudOfImmortalityAbilityHandler = ShroudOfImmortalityAbilityHandler;
